module.exports = __webpack_public_path__ + "eye.f3915203.svg";